import React, { useState } from "react";
import Tabs from "../Tabs/Tabs";
import EditTab from "./EditTab";
import PlaygroundTab from "./PlaygroundTab";

const TABS = {
  CONFIGURE: "Configure Agent",
  TEST: "Test Agent",
};

const AgentPage = ({ agentId }) => {
  // Default langsung ke Test Agent (chat) — Configure disembunyikan sementara untuk beta test
  const [activeTab, setActiveTab] = useState(TABS.TEST);

  return (
    <div className="flex flex-col h-full">
      {/* Tab bar disembunyikan sementara untuk beta test */}
      {/* <div className="sticky top-0 z-20 border-b border-slate-200/80 bg-slate-50/95 backdrop-blur supports-[backdrop-filter]:bg-slate-50/85">
        <Tabs
          tabs={[TABS.CONFIGURE, TABS.TEST]}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div> */}

      <div
        className={`min-h-0 flex-1 ${
          activeTab === TABS.TEST ? "overflow-hidden" : "overflow-auto"
        }`}
      >
        {activeTab === TABS.CONFIGURE && <EditTab agentId={agentId} />}
        {activeTab === TABS.TEST && <PlaygroundTab agentId={agentId} />}
      </div>
    </div>
  );
};

export default AgentPage;
